import { setupStore } from "./reducer";

// ==============================|| REDUX - MAIN STORE ||============================== //

const store = setupStore();

export { store };
